module.exports = __webpack_public_path__ + "static/img/direct_hit_movie_thum_05.3701579.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/movie/direct_hit_movie_thum_05.jpg
// module id = CphK
// module chunks = 0